import "./ImageComponent.scss";

export default function ImageComponent() {
    return (
        <div className='imageComponent-container'>
            <img
                className='pfoto-image'
                src='/loginpage/right.png'
                alt='Pfoto'
            />
        </div>
    );
}
